import { useCallback } from 'react';

import { AnalyticsService } from '../services/analytics-service';

const INSURANCE_HYPERLINK_CLICKED = 'Insurance Grid Hyperlink Clicked';
const INSURANCE_MODAL_VIEWED = 'Orders Grid Insurance Modal Viewed';
const INSURANCE_MODAL_DROPDOWN_UPDATED = 'Orders Grid Insurance Modal Dropdown value updated';
const INSURANCE_MODAL_BUTTON_CLICKED = 'Orders Grid Insurance Modal Button Clicked';

export type InsuranceModalButton = 'Save Changes' | 'Cancel' | 'Close';

export const useTrackInsuranceHyperlinkClicked = (): ((hyperlinkText: string) => void) => {
  return useCallback((hyperlinkText: string) => {
    AnalyticsService.trackManualEvent(INSURANCE_HYPERLINK_CLICKED, { hyperlinkText });
  }, []);
};

export const useTrackInsuranceModalViewed = (): ((hyperlinkText: string) => void) => {
  return useCallback((hyperlinkText: string) => {
    AnalyticsService.trackManualEvent(INSURANCE_MODAL_VIEWED, { hyperlinkText });
  }, []);
};

export const useTrackInsuranceDropdownUpdated = (): ((fromValue: string, toValue: string) => void) => {
  return useCallback((fromValue: string, toValue: string) => {
    AnalyticsService.trackManualEvent(INSURANCE_MODAL_DROPDOWN_UPDATED, { fromValue, toValue });
  }, []);
};

type InsuranceModalButtonClickedParams = {
  buttonClicked: InsuranceModalButton;
  originalInsuranceValue: string;
  savedInsuranceValue: string | null;
  savedInsuranceCheckboxValue: boolean | null;
  insuranceAmount: number | null;
};

export const useTrackInsuranceModalButtonClicked = (): ((params: InsuranceModalButtonClickedParams) => void) => {
  return useCallback((params: InsuranceModalButtonClickedParams) => {
    AnalyticsService.trackManualEvent(INSURANCE_MODAL_BUTTON_CLICKED, params);
  }, []);
};
